export const NOW_IN_MILLI_SECONDS = new Date().getTime();

export const convertRangeToTime = (number: number, useAMPM?: boolean) => {
  if (number < 0) {
    if (useAMPM) {
      return "12:00am";
    }
    return "00:00";
  }

  if (number > 95) {
    if (useAMPM) {
      return "11:59pm";
    }
    return "23:59";
  }

  let hours: string | number = Math.floor(number / 4);
  let minutes: string | number = (number % 4) * 15;

  if (hours < 10) {
    hours = "0" + hours;
  }

  if (minutes === 0) {
    minutes = "00";
  }

  let time = hours + ":" + minutes;

  if (useAMPM) {
    const ampm = (hours as number) >= 12 ? "pm" : "am";
    hours = (hours as number) % 12 || 12;
    if (hours < 10) {
      hours = "0" + hours;
    }
    time = hours + ":" + minutes + ampm;
  }

  return time;
};
